'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _flickity = require('flickity');

var _flickity2 = _interopRequireDefault(_flickity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var releatedProductSlider;
function relatedProducts() {
    var relatedProductsSliderEl = document.querySelector('.related-products__slider');

    if (!relatedProductsSliderEl) {
        return;
    }

    if ((0, _jquery2.default)(window).width() <= 750) {
        if (releatedProductSlider) {
            releatedProductSlider.activate();
        } else {
            releatedProductSlider = new _flickity2.default(relatedProductsSliderEl, {
                wrapAround: true,
                pageDots: false
            });
        }
    } else {
        if (releatedProductSlider) {
            releatedProductSlider.deactivate();
        }
    }
};

relatedProducts();

(0, _jquery2.default)(document).on('shopify:section:load', function () {
    relatedProducts();
});

(0, _jquery2.default)(window).resize(function () {
    relatedProducts();
});